/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';
import type { TopUp } from './TopUp';
import {
    TopUpFromJSON,
    TopUpFromJSONTyped,
    TopUpToJSON,
} from './TopUp';

/**
 * 
 * @export
 * @interface PageableTopUps
 */
export interface PageableTopUps {
    /**
     * 
     * @type {Array<TopUp>}
     * @memberof PageableTopUps
     */
    result: Array<TopUp>;
    /**
     * 
     * @type {Page}
     * @memberof PageableTopUps
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableTopUps interface.
 */
export function instanceOfPageableTopUps(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableTopUpsFromJSON(json: any): PageableTopUps {
    return PageableTopUpsFromJSONTyped(json, false);
}

export function PageableTopUpsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableTopUps {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(TopUpFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableTopUpsToJSON(value?: PageableTopUps | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(TopUpToJSON)),
        'page': PageToJSON(value.page),
    };
}

